// NgRx reducers
import { combineReducers } from '@ngrx/store';
import { currentReportIndex, currentReportTypeIndex, customPdfReportMenu, reportMenuFetchRequest, } from './report-menu/report-menu.reducers';
import { currentWizardStepIndex } from './wizard-step/wizard-step.reducer';
import { reportTitle, selectedReport } from './selected-report/selected-report.reducer';
import { primarySecurity, secondarySecurity, comparisonSecurities, } from './report-securities/report-securities.reducers';
import { coverPageInfo, userPreferenceFetchRequest, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/cover-page/cover-page.reducers';
import { generatingSavedReport, generateReportConfig, generationErrors, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/generate/generate.reducers';
import { compTableSecuritiesChoice, fundChartSecuritiesChoice, scatterPlotSecuritiesChoice, timeseriesTableSecuritiesChoice, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/saved-asset-securities-choices/saved-asset-securities-choices.reducer';
import { savedHypotheticalId } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/saved-hypothetical-id/saved-hypothetical-id.reducer';
import { savedAnalysisPlanId } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/saved-analysis-plan-id/saved-analysis-plan-id.reducer';
import { talkingPoints } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/talking-points/talking-points.reducer';
import { namingConvention } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/naming-convention/naming-convention-reducer';
import { securityLevelValues } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/dollar-conversion-level-selector/dollar-conversion-level.reducer';
import { transitionAnalyses } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/transition_analyses/transition-analyses.reducer';
import { riskProfile } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/risk-profile/risk-profile.reducer';
import { exportOption } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/export-option/export-option.reducers';
import { generateModalSelectedFolderableOperation } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/generate-modal-selected-folderable-operation/generate-modal-selected-folderable-operation.reducer';
export const CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY = 'customPdfReportModal';
export const customPdfReportModal = combineReducers({
    comparisonSecurities,
    coverPageInfo,
    currentReportIndex,
    currentReportTypeIndex,
    currentWizardStepIndex,
    customPdfReportMenu,
    exportOption,
    generatingSavedReport,
    generateReportConfig,
    generationErrors,
    namingConvention,
    primarySecurity,
    reportMenuFetchRequest,
    reportTitle,
    riskProfile,
    savedHypotheticalId,
    savedAnalysisPlanId,
    secondarySecurity,
    selectedReport,
    talkingPoints,
    userPreferenceFetchRequest,
    fundChartSecuritiesChoice,
    scatterPlotSecuritiesChoice,
    compTableSecuritiesChoice,
    timeseriesTableSecuritiesChoice,
    securityLevelValues,
    transitionAnalyses,
    generateModalSelectedFolderableOperation,
});
